import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion
});

export const api = {
  getList() {
    return instance.get("admin/store_logs");
  }
};
